import { createFileRoute, Outlet } from '@tanstack/react-router'

/**
 * A agenda tem duas telas: a semana, que ela abre todo dia, e a
 * disponibilidade, que ela mexe de vez em quando. O trilho leva à semana, e a
 * lateral da semana tem o botão da disponibilidade.
 */
export const Route = createFileRoute('/_app/app/agenda')({
  staticData: { crumb: { label: 'Agenda' } },
  component: Outlet,
})
